import script from "./StorageDefaultsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StorageDefaultsModal.vue?vue&type=script&setup=true&lang=js"

import "./StorageDefaultsModal.vue?vue&type=style&index=0&id=04f35ed3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f35ed3"]])

export default __exports__